var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{attrs:{"value":_vm.value,"fetch-suggestions":_vm.symbolsList,"disabled":_vm.disabled,"clearable":""},on:{"input":_vm.emitInput,"change":_vm.emitChange,"select":_vm.emitSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }